import {getRequest} from "./api";

export const initMenu = (router, store) => {
    if (store.state.routes.length > 0) {
        return;
    }
    getRequest("/web/system/config/menu/").then(response => {
        if (response.data) {
            let routes = JSON.parse(JSON.stringify(response.data));
            let fmtRoutes = formatRoutes(routes.menus);
            router.addRoutes(fmtRoutes);
            store.commit('INIT_ROUTES', fmtRoutes);
        }
    })
};

export const formatRoutes = (routes) => {
    let fmRoutes = [];
    routes.forEach(router => {
        let {
            path,
            component,
            redirect,
            name,
            meta,
            iconCls,
            children
        } = router;
        if (children && children instanceof Array) {
            children = formatRoutes(children);
        }
        let fmRouter = {
            path: path,
            name: name,
            iconCls: iconCls,
            meta: meta,
            redirect: redirect,
            children: children,
            component(resolve) {
                if (component.startsWith('Index')) {
                    require(['../views/' + component + '.vue'], resolve);
                } else if (component.startsWith('Center')) {
                    require(['../views/common/' + component + '.vue'], resolve);
                } else if (component.startsWith('DetailInfo')) {
                    require(['../views/company/' + component + '.vue'], resolve);
                } else if (component.startsWith('DataProperty')) {
                    require(['../views/company/' + component + '.vue'], resolve);
                } else if (component.startsWith('PropertyExamine1')) {
                    require(['../views/company/' + component + '.vue'], resolve);
                } else if (component.startsWith('PropertyExamine2')) {
                    require(['../views/company/' + component + '.vue'], resolve);
                } else if (component.startsWith('PropertyExamine3')) {
                    require(['../views/company/' + component + '.vue'], resolve);
                } else if (component.startsWith('DetailInfoExamine')) {
                    require(['../views/company/' + component + '.vue'], resolve);
                } else if (component.startsWith('MessageInfo')) {
                    require(['../views/company/' + component + '.vue'], resolve);
                } else if (component.startsWith('PropertyManage')) {
                    require(['../views/company/' + component + '.vue'], resolve);
                } else if (component.startsWith('DetailInfoManage')) {
                    require(['../views/company/' + component + '.vue'], resolve);
                } else if (component.startsWith('CertificateManage')) {
                    require(['../views/company/' + component + '.vue'], resolve);
                } else if (component.startsWith('ManageHome')) {
                    require(['../views/common/' + component + '.vue'], resolve);
                } else if (component.startsWith('Security')) {
                    require(['../views/company/' + component + '.vue'], resolve);
                } else if (component.startsWith('PassWord')) {
                    require(['../views/company/' + component + '.vue'], resolve);
                } else if (component.startsWith('PassWordManage')) {
                    require(['../views/company/' + component + '.vue'], resolve);
                } else if (component.startsWith('DataAssetsManage')) {
                    require(['../views/company/' + component + '.vue'], resolve);
                } else if (component.startsWith('ToDoInfo')) {
                    require(['../views/company/' + component + '.vue'], resolve);
                } else if (component.startsWith('PermissionManage')) {
                    require(['../views/company/' + component + '.vue'], resolve);
                } else if (component.startsWith('DataComplianceManager')) {
                    require(['../views/manager/DataCompliance/' + component + '.vue'], resolve);
                } else if (component.startsWith('/DataQualityEvaluation')) {
                    require(['../views/manager/QualityEvaluation/' + component + '.vue'], resolve);
                }
            }
        };
        fmRoutes.push(fmRouter);
    });
    return fmRoutes;
};